import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SeoMetadataService {

  baseUrl = environment.baseUrl;


  constructor(private http: HttpClient,) { }

  updateSeoMetaData(formData: any) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('entity_type', formData.entity_type);
    myFormData.append('entity_id', formData.entity_id);
    myFormData.append('meta_title', formData.meta_title);
    myFormData.append('meta_description', formData.meta_description);
    myFormData.append('meta_keywords', formData.meta_keywords);
    myFormData.append('canonical_url', formData.canonical_url);
    myFormData.append('og_title', formData.og_title);
    myFormData.append('og_description', formData.og_description);
    myFormData.append('og_image', formData.og_image);
    myFormData.append('og_url', formData.og_url);
    myFormData.append('og_type', formData.og_type);
    return this.http.post(this.baseUrl + '/update_seo_metadata', myFormData, {
      headers: headers
    });
  }




  update_color(formData: any) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('id', formData.id);
    myFormData.append('color_name', formData.color_name);
    myFormData.append('color_code', formData.color_code);
    return this.http.post(this.baseUrl + '/update_color/' + formData.id, myFormData, {
      headers: headers
    });
  }


}
